export function StringCanBeNumber(val: any): boolean {
  return val && (val instanceof String || typeof val === 'string') && !isNaN(+val);
}
